import {PLAYER_COLORS} from "../../configs/colors";
import {getContrastRatio} from "../colors/getReadableInkColor";
import {getPlayerHexColor} from "../players/getPlayerHexColor";
import {NEUTRAL_PLAYER_COLOR} from "../../constants/players";

// Середина градиента лицевой стороны каменной кнопки дизайн-системы
// (--gui-btn-face в src/styles/gameUi/tokens.css: #4a4d53 → #2c2e32)
export const GUI_STONE_FACE_COLOR = '#3b3e42';

// Порог контраста по WCAG с камнем, ниже которого силуэт цвета игрока
// сливается с каменным гексом. Цвета игроков делятся с запасом: у самого
// контрастного из темных (светло-коричневый) 2.8, у наименее контрастного из
// светлых (оранжевый) 4.1
export const STONE_BLEND_CONTRAST_THRESHOLD = 3;

// Светлые цвета с обводкой по решению владельца: контраст у них достаточный, но
// без нее силуэт смотрится хуже. Порогом их не выделить: у голубого контраст 4.8,
// а у оранжевого, розового и салатового, которым обводка не нужна, он ниже
const LIGHT_COLORS_WITH_STONE_OUTLINE = [PLAYER_COLORS.SKY_BLUE];

/**
 * Нужна ли силуэту цвета игрока белая обводка на каменном гексе жетона (жетоны
 * типов отрядов в панели найма): темный цвет с камнем сливается
 * @param {string} playerColor - цвет игрока (PLAYER_COLORS)
 * @returns {boolean}
 */
export const checkIfColorBlendsWithStone = (playerColor) => (
  // Нейтралу обводку дает сам UnitIcon, вторая сделала бы ее вдвое толще
  playerColor !== NEUTRAL_PLAYER_COLOR && (LIGHT_COLORS_WITH_STONE_OUTLINE.includes(playerColor)
  || getContrastRatio(getPlayerHexColor(playerColor), GUI_STONE_FACE_COLOR) < STONE_BLEND_CONTRAST_THRESHOLD)
);
